import { LEVELS } from './logic/gameConfig';

export const shooterDefinition = {
  id: 'shooter',
  name: 'Arcade Shooter',
  shortName: 'Shooter',
  summary: 'Classic sector-clearing starfighter action with bosses, hazards, and powerups.',
  instructions: 'Move with arrows, WASD, or touch joystick. Enter or Space confirms. Shooting is automatic.',
  playfieldLabel: 'Arcade Shooter playfield',
  storageNamespace: 'shooter',
  themeClass: 'theme-shooter',
  levels: LEVELS,
};
